<template>
  <div>
    <ca-heading text="Funções" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">Nova função</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-async-content-wrapper
          :key="wrapperKey"
          :on-fetch="getJobDescriptions"
          :on-fetch-success="setJobDescriptions">
          <ca-table v-if="jobDescriptions" :key="tableKey">
            <ca-tr slot="header">
              <ca-th>CBO</ca-th>
              <ca-th>Descrição</ca-th>
              <ca-th>Compartilhado</ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr
              v-for="(jobDescription, index) in jobDescriptions.content"
              :key="index"
              @click="onView(jobDescription.id)">
              <ca-td>
                {{ jobDescription.cbo }}
              </ca-td>
              <ca-td>
                {{ jobDescription.description }}
              </ca-td>
              <ca-td>
                {{ jobDescription.shared ? 'Sim' : 'Não' }}
              </ca-td>
              <ca-td>
                <ca-button
                  size="small"
                  class="ca-u-min-margin-right"
                  @click.stop="onEdit(jobDescription.id)">
                  Editar
                </ca-button>
                <ca-button size="small" @click.stop="onDelete(index, jobDescription.id)">
                  Excluir
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col class="ca-u-text-center">
        <ca-pagination
          v-if="jobDescriptions.totalPages > 1"
          v-model="currentPage"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center"
          :total-pages="jobDescriptions.totalPages">
        </ca-pagination>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import {
  getJobDescriptions, deleteJobDescription,
} from './jobDescriptionService';

export default {
  name: 'JobDescriptionsPage',
  data() {
    return {
      wrapperKey: 0,
      tableKey: 0,
      jobDescriptions: {},
      currentPage: 0,
    };
  },
  watch: {
    currentPage() {
      this.updateList();
    },
  },
  methods: {
    getJobDescriptions() {
      return getJobDescriptions({ page: this.currentPage });
    },
    setJobDescriptions(response) {
      this.jobDescriptions = response;

      setTimeout(() => {
        this.tableKey++;
      }, 500);
    },
    updateList() {
      this.wrapperKey++;
    },
    onNew() {
      this.$router.push({ name: 'NewJobDescription' });
    },
    onView(id) {
      this.$router.push({ name: 'ViewJobDescription', params: { id } });
    },
    onEdit(id) {
      this.$router.push({ name: 'EditJobDescription', params: { id } });
    },
    onDelete(index, id) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteJobDescription(id)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$delete(this.jobDescriptions, index);
              this.updateList();
            })
            .catch(e => {
              this.$toaster[e.status](e.message);
            });
        },
      });
    },
  },
};
</script>
